/**
 * BUG-102 / ADR-025 — is this social post with Buffer or Zernio now?
 *
 * Shared between the API and the SPA for the same reason `x-thread.ts` is:
 * the API refuses edits and deletes to a handed-off post, and the drawer
 * makes it read-only and offers Cancel post. If the two ever disagreed, the
 * screen would offer an edit the server refuses — or, worse, the reverse.
 *
 * `scheduled` with the provider's post id means the provider holds it; a
 * `scheduled` row without one is a manual post nothing was sent for.
 *
 * Pure. No imports, no framework.
 */
export function isHandedOff(status: string, dispatchPostId: string | null | undefined): boolean {
  return status === "scheduled" && !!dispatchPostId;
}
